import { render, staticRenderFns } from "./bodyprint-queue-table.vue?vue&type=template&id=ace1080e"
import script from "./bodyprint-queue-table.vue?vue&type=script&lang=js"
export * from "./bodyprint-queue-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports